// @ts-nocheck
import React, { CSSProperties } from "react";
import { observer } from "mobx-react";
import clsx from "clsx";

export interface ContentProps {
  pageName?: string | JSX.Element;
  wrapperCss?: CSSProperties;
  onHeaderClick?: () => void;
  pageBodyClasses?: string;
  className?: string;
  disablePadding?: boolean;
}

@observer
export default class Page extends React.Component<ContentProps> {
  render() {
    return (
      <div className={"content-container"} style={{ height: "100%" }}>
        {this.props.pageName ? (
          <h1
            id={"scrollElement1"}
            className={
            clsx(
              this.props.className,
              this.props.disablePadding ? '' : '!p-4 lg:!px-8 lg:!pt-8',
              "content-header text-primary-2 !text-[24px] lg:!text-[30px] leading-[48px]"
            )}
          >
            {this.props.pageName}
          </h1>
        ) : (
          <></>
        )}
        <div
          className={
            "page-body" +
            (this.props.pageBodyClasses ? " " + this.props.pageBodyClasses : "")
          }
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}
